export const baseDev="";
export const baseProd="https://cs.ghwline.com/mdataserver";
export  const filerequesturl="https://cs.ghwline.com/mdataserver/masterData/saveExcel"
export  const filerequesturlPic="https://cs.ghwline.com/mdataserver/system/uploadFile"
export  const file_url='https://cs.ghwline.com'